import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { getBasePath } from '../utils/basePath';

// A "Data sources" link in the map's attribution control (#1289).
//
// Parcel polygons drawn on a map come from public agencies whose licences
// ask for credit, and the credits live on the /data-sources page. The
// attribution control is where a map reader already looks for them, so the
// link goes there instead of in the top nav. It is added to the MAP, not to a
// basemap TileLayer, so it stays when the user switches basemap and it does
// not displace the basemap's own credit: Leaflet joins every attribution
// string into the one control line, and each basemap keeps its own.
//
// The href carries the router basename (getBasePath(), the same value
// index.js hands to BrowserRouter) because the attribution is plain HTML
// that Leaflet writes into the DOM, not a router <Link>. It opens in a new
// tab so the search map's viewport and filters survive the click.
export const DATA_SOURCES_PATH = '/data-sources';

const escapeAttr = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

export function dataSourcesAttributionHtml(basePath = getBasePath()) {
  const href = escapeAttr(`${basePath}${DATA_SOURCES_PATH}`);
  return `<a href="${href}" target="_blank" rel="noopener noreferrer">Data sources</a>`;
}

export default function DataSourcesAttribution() {
  const map = useMap();

  useEffect(() => {
    // `attributionControl={false}` on a MapContainer leaves this undefined.
    const control = map && map.attributionControl;
    if (!control) return undefined;
    const html = dataSourcesAttributionHtml();
    control.addAttribution(html);
    return () => control.removeAttribution(html);
  }, [map]);

  return null;
}
